import React from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  return (
    <header className="bg-white shadow-sm sticky top-0 z-50 font-vazirmatn" dir="rtl">
      <nav className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Right Side: Logo */}
          <div className="flex-shrink-0">
            <span className="text-xl font-bold text-gray-800">
              درمووایز
            </span>
          </div>

          {/* Left Side: CTA Button */}
          <div className="flex-shrink-0">
            <Link
              to="/login"
              className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors duration-200"
            >
              ورود / ثبت نام
            </Link>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header; 